module.exports = __webpack_public_path__ + "static/media/side menu icon.c5c1d255.svg";